/** Product weight is the weight of one box; loose pieces carry a fraction of it. */
export function totalProductWeightKg(lines: ReadonlyArray<{qtyBoxes:number;piecesPerBox:number;weightKg:number|null}>): number {
  return lines.reduce((total,line) => {
    const perBox = Math.max(line.piecesPerBox,1);
    // Recover whole pieces from the stock ledger's three-decimal box quantity.
    const boxes = Math.round(line.qtyBoxes * perBox) / perBox;
    return total + boxes * (line.weightKg ?? 0);
  },0);
}
